import api from "../apiConfig";
import paramsFactory from "../../utils/paramsFactory";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  index(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/item-request?${p}`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },
  showById(id) {
    return api.get(`/api/v1/item-request/${id}`);
  },
  create(data) {
    return api.post(`/api/v1/item-request`, data);
  },
  mrAction(id, data) {
    return api.post(`/api/v1/item-request/${id}/mr-action`, data, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },
  stockCheck(data) {
    return api.post(`/api/stock-check`, data, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },
  reply(data) {
    return api.post(`/api/v1/reply`, data);
  },
  deleteReply(id) {
    return api.delete(`/api/v1/reply/${id}`);
  },
  changeReplyPrivacy(id, data) {
    return api.post(`/api/v1/reply/change-privacy/${id}`, data);
  },
};
